import {Routes} from '@angular/router';
import {OnboardingSignUpViewComponent} from './onboarding-sign-up';

export const ONBOARDING_SIGN_UP_ROUTES: Routes = [
    { path: 'sign-up', component: OnboardingSignUpViewComponent }
];
